export default __webpack_public_path__ + "static/media/green-squares.9a99ad77.svg";